import moment from 'moment-timezone';

// The check-out picker edits the tour's clock. A UTC-mode moment made the
// hour the operator typed the UTC hour, so 15:45 in Manila was stored as
// 15:45Z (11:45 PM local) and the post-trip survey waited for that instant.

export function checkoutPickerMoment(endTs, tripTimeZone) {
    if (!endTs) {
        return null;
    }
    return moment.utc(endTs).tz(tripTimeZone || 'UTC');
}

export function checkoutInstantIso(picked) {
    if (!picked) {
        return null;
    }
    return moment(picked).toISOString();
}

// Midnight of a 'YYYY-MM-DD' trip date on the tour's clock, as a moment.
// Midnight UTC showed as the evening before on a US tour.
export function tripDateMidnight(tripDate, tripTimeZone) {
    if (!tripDate) {
        return null;
    }
    return moment.tz(tripDate, 'YYYY-MM-DD', tripTimeZone || 'UTC');
}

// CP-8392: the server never moves a booking's own check-out when its date
// changes, so the form does. Moving the trip date N days moves the check-out
// N days on the tour's clock, keeping the time the operator picked (3:00 PM
// stays 3:00 PM across a DST change). An empty check-out takes midnight of
// the new date, as ticking the box after picking a date does.
export function checkoutForNewTripDate(endTs, oldDate, newDate, tripTimeZone) {
    if (!newDate) {
        return endTs;
    }
    if (!endTs) {
        return tripDateMidnight(newDate, tripTimeZone).toISOString();
    }
    if (!oldDate || oldDate === newDate) {
        return endTs;
    }
    const days = moment.utc(newDate, 'YYYY-MM-DD').diff(moment.utc(oldDate, 'YYYY-MM-DD'), 'days');
    return checkoutPickerMoment(endTs, tripTimeZone).add(days, 'days').toISOString();
}
